"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalDetails = void 0;
Object.defineProperty(exports, "findPersonById", {
  enumerable: true,
  get: function get() {
    return _personalDetailsUtils.findPersonById;
  }
});
Object.defineProperty(exports, "getSocialMediaIcon", {
  enumerable: true,
  get: function get() {
    return _personalDetailsUtils.getSocialMediaIcon;
  }
});
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _socialMediaIcons = _interopRequireDefault(require("./socialMediaIcons"));
var _personalDetailsUtils = require("./personalDetailsUtils.js");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PersonalDetails = props => {
  const {
    person,
    imageUrl,
    t
  } = props;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const goBack = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content__heading"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "con-heading con-heading__l--margin-bottom-0"
  }, person.name), /*#__PURE__*/_react.default.createElement("span", {
    className: "con-subheading"
  }, person.jobTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speaker"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speaker__details"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text"
  }, person.description), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-social-media__container"
  }, /*#__PURE__*/_react.default.createElement(_socialMediaIcons.default, {
    links: person.links
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "con-social-media__container--back-button",
    onClick: () => goBack()
  }, t('Common.Back')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speaker__image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "con-speaker-image",
    src: imageUrl,
    alt: person.name
  })))));
};
exports.PersonalDetails = PersonalDetails;
PersonalDetails.propTypes = {
  person: _propTypes.default.object,
  t: _propTypes.default.func
};